module.exports = __webpack_public_path__ + "static/media/arrow-down.0e6a3286.svg";